var Enum = Enum || { MEEDY : {}};

Enum.GENERATION_STATUS = {
    IN_PROGRESS: 'IN_PROGRESS',
    COMPLETED: 'COMPLETED',
    FAILED: 'FAILED'
};

Object.freeze(Enum.EXPORT_TYPE);